import axios from "axios";
import { format } from "date-fns";
import { ApiError, ApiErrorBody, ApiFieldErrors } from "types/apiError";

export function formatDate(dateString: string) {
  if (!dateString) return;
  const date = new Date(dateString.substring(0, 10)).toISOString().slice(0, -1);

  return format(new Date(date), "MMMM dd, yyyy"); // ex: April 27, 2022;
}

export function parseTimeToAmPm(timestamp: string) {
  if (!timestamp) return;
  const date = new Date(timestamp);

  return format(date, "hh:mm a"); // ex: 04:12 PM
}

export function numberWithCommas(x: number | string) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function formatCentsToDollar(cents: number) {
  const dollarNumber = cents / 100;
  return dollarNumber.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
}

export function getCurrentEasternTimezoneName(): string {
  const intlFormat = new Intl.DateTimeFormat("en-US", { timeZone: "America/New_York", timeZoneName: "short" });
  return intlFormat.formatToParts(new Date()).find((x) => x.type === "timeZoneName")!.value;
}

const pluralRules = new Intl.PluralRules("en-US");

export function pluralize(count: number, singular: string, plural: string) {
  const grammaticalNumber = pluralRules.select(count);
  switch (grammaticalNumber) {
    case "one":
      return count + " " + singular;
    case "other":
      return count + " " + plural;
    default:
      throw new Error("Unknown: " + grammaticalNumber);
  }
}

export function isAxiosError(error: unknown): error is ApiError {
  return axios.isAxiosError<ApiErrorBody>(error);
}

export function apiErrorList(error: ApiError): string[] | undefined {
  const errors = error.response?.data?.errors;
  return Array.isArray(errors) ? errors : undefined;
}

export function apiFieldErrors(error: ApiError): ApiFieldErrors | undefined {
  const errors = error.response?.data?.errors;
  return errors && !Array.isArray(errors) ? errors : undefined;
}

export function apiFieldError(error: ApiError, field: string): string | undefined {
  const value = apiFieldErrors(error)?.[field];
  return Array.isArray(value) ? value[0] : value;
}

export function humanize(str: string) {
  return str.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
}
